/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accent_SignatureInputs */

const en_accent_signature = /** @type {(inputs: Accent_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accent Signature`)
};

const es_accent_signature = /** @type {(inputs: Accent_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firma de acento`)
};

const fr_accent_signature = /** @type {(inputs: Accent_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur d'accentuation`)
};

const de_accent_signature = /** @type {(inputs: Accent_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akzent-Signatur`)
};

const ja_accent_signature = /** @type {(inputs: Accent_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセントシグネチャー`)
};

const zh_accent_signature = /** @type {(inputs: Accent_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标志性强调色`)
};

const ar_accent_signature = /** @type {(inputs: Accent_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لون التمييز المميز`)
};

const id_accent_signature = /** @type {(inputs: Accent_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksen Khas`)
};

const it_accent_signature = /** @type {(inputs: Accent_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore di Accento`)
};

const ru_accent_signature = /** @type {(inputs: Accent_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цветовой акцент`)
};

const pt_accent_signature = /** @type {(inputs: Accent_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor de Destaque`)
};

const ko_accent_signature = /** @type {(inputs: Accent_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`악센트 컬러 시그니처`)
};

/**
* | output |
* | --- |
* | "Accent Signature" |
*
* @param {Accent_SignatureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const accent_signature = /** @type {((inputs?: Accent_SignatureInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accent_SignatureInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accent_signature(inputs)
	if (locale === "es") return es_accent_signature(inputs)
	if (locale === "fr") return fr_accent_signature(inputs)
	if (locale === "de") return de_accent_signature(inputs)
	if (locale === "ja") return ja_accent_signature(inputs)
	if (locale === "zh") return zh_accent_signature(inputs)
	if (locale === "ar") return ar_accent_signature(inputs)
	if (locale === "id") return id_accent_signature(inputs)
	if (locale === "it") return it_accent_signature(inputs)
	if (locale === "ru") return ru_accent_signature(inputs)
	if (locale === "pt") return pt_accent_signature(inputs)
	return ko_accent_signature(inputs)
});